import { Role } from '../types/user.type';

const ADMIN_ROLE = 'admin' as Role['name'];
const AGENT_ROLE = 'agent' as Role['name'];
const MENTOR_ROLE = 'mentor' as Role['name'];
const SUPERVISOR_ROLE = 'supervisor' as Role['name'];
const TICKETING_ADMIN_ROLE = 'ticketing-admin' as Role['name'];
const TICKETING_MEMBER_ROLE = 'ticketing-member' as Role['name'];

const TICKETING_ROLES = [TICKETING_ADMIN_ROLE, TICKETING_MEMBER_ROLE] as Role['name'][];
const NL_CARE_ROLES = [AGENT_ROLE, MENTOR_ROLE, SUPERVISOR_ROLE, ADMIN_ROLE] as Role['name'][];
const ALL_ROLES = [...TICKETING_ROLES, ...NL_CARE_ROLES] as Role['name'][];
const NO_ROLES = [] as Role['name'][];

export {
  ADMIN_ROLE,
  AGENT_ROLE,
  MENTOR_ROLE,
  SUPERVISOR_ROLE,
  TICKETING_ADMIN_ROLE,
  TICKETING_MEMBER_ROLE,
  TICKETING_ROLES,
  NL_CARE_ROLES,
  ALL_ROLES,
  NO_ROLES,
};
